import GetAnalyticAccountsBalanceSheetDto from 'backend2/dtos/accounting/Accounts/GetAnalyticAccountsBalanceSheetDto';
import GetSyntheticAccountsBalanceSheetDto from 'backend2/dtos/accounting/Accounts/GetSyntheticAccountsBalanceSheetDto';
import GetOperations from 'backend2/dtos/accounting/Operations/GetOperations.dto';
import GetOperationsGroupingDateDto from 'backend2/dtos/accounting/Operations/grouping/GetOperationsGroupingDate.dto';
import GetOperationsGroupingTypeDto from 'backend2/dtos/accounting/Operations/grouping/GetOperationsGroupingType.dto';
import FullOperation, { Payment } from 'backend2/dtos/accounting/Operations/Operation.dto';
import GetHistory from 'backend2/dtos/common/History/GetHistory.dto';
import { IScheme } from 'backend2/interfaces/accounts';
import { IFullHistory } from 'backend2/interfaces/history';
import { IFullOperation, IOperationsGroupingDate, IOperationsGroupingType } from 'backend2/interfaces/operations';
import { DeepPartial } from 'backend2/types';
import { AnalyticBalanceSheet, SyntheticBalanceSheet } from 'backend2/types/accounts';
import { BackendUrls } from 'src/constants/url';
import fetch from 'src/libs/fetch';

export function fetchAccountsScheme() {
	return fetch<IScheme>({
		method: 'GET',
		url: BackendUrls.GetAccountsScheme,
	});
}

export function fetchSyntheticAccountsBalanceSheet(accountId: number, params?: GetSyntheticAccountsBalanceSheetDto) {
	return fetch<SyntheticBalanceSheet>({
		method: 'GET',
		url: BackendUrls.GetSyntheticAccountsBalanceSheet.replace('{accountId}', `${accountId}`),
		params,
	});
}

export function fetchAnalyticAccountsBalanceSheet(accountId: number, params?: GetAnalyticAccountsBalanceSheetDto) {
	return fetch<AnalyticBalanceSheet>({
		method: 'GET',
		url: BackendUrls.GetAnalyticAccountsBalanceSheet.replace('{accountId}', `${accountId}`),
		params,
	});
}

export function createOperation(body: DeepPartial<FullOperation>) {
	return fetch<IFullOperation>({
		method: 'POST',
		url: BackendUrls.CreateOperation,
		body,
	});
}

export function updateOperation(body: DeepPartial<FullOperation>, operationId: bigint) {
	return fetch<IFullOperation>({
		method: 'PATCH',
		url: BackendUrls.UpdateOperation.replace('{operationId}', String(operationId)),
		body,
	});
}

export function fetchOperations(params?: GetOperations) {
	return fetch<IFullOperation[]>({
		method: 'GET',
		url: BackendUrls.GetAccountsOperations,
		params,
	});
}

export function removeOperation(operationId: bigint) {
	return fetch<IFullOperation>({
		method: 'PUT',
		url: BackendUrls.RemoveOperation.replace('{operationId}', String(operationId)),
	});
}

export function approveOperation(operationId: bigint) {
	return fetch<IFullOperation>({
		method: 'PUT',
		url: BackendUrls.ApproveOperation.replace('{operationId}', String(operationId)),
	});
}

export function unapproveOperation(operationId: bigint) {
	return fetch<IFullOperation>({
		method: 'PUT',
		url: BackendUrls.UnapproveOperation.replace('{operationId}', String(operationId)),
	});
}

export function updateOperationPayments(body: Pick<Payment, 'accountId' | 'amount'>[], operationId: bigint) {
	return fetch<IFullOperation>({
		method: 'PATCH',
		url: BackendUrls.UpdateOperationPayments.replace('{operationId}', String(operationId)),
		body,
	});
}

export function fetchOperationsGroupingDate(params?: GetOperationsGroupingDateDto) {
	return fetch<IOperationsGroupingDate[]>({
		method: 'GET',
		url: BackendUrls.GetOperationsGroupingData,
		params,
	});
}

export function fetchOperationsGroupingType(params: GetOperationsGroupingTypeDto) {
	return fetch<IOperationsGroupingType[]>({
		method: 'GET',
		url: BackendUrls.GetOperationsGroupingType,
		params,
	});
}

export function canIUpdateOperation(operationId: bigint | string) {
	return fetch<void>({
		method: 'GET',
		url: BackendUrls.GetСanIUpdateOperation.replace('{operationId}', String(operationId)),
	});
}
export function canIChangeApproveStateOperation(operationId: bigint | string) {
	return fetch<void>({
		method: 'GET',
		url: BackendUrls.GetСanIChangeApproveStateOperation.replace('{operationId}', String(operationId)),
	});
}
export function canIRemoveOperation(operationId: bigint | string) {
	return fetch<void>({
		method: 'GET',
		url: BackendUrls.GetСanIRemoveOperation.replace('{operationId}', String(operationId)),
	});
}

export function fetchOperationsHistory(params?: GetHistory) {
	return fetch<IFullHistory[]>({
		method: 'GET',
		url: BackendUrls.GetOperationsHistory,
		params,
	});
}
